import { Outlet } from 'react-router-dom'

import { Features } from 'generated/featureDefinitions'

import { GoogleMapsProvider } from 'modules/core/components/GoogleMaps/GoogleMapsProvider'
import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import { useFeatures } from 'modules/core/hooks/useFeatures'

import WorkplaceDetailsComponent from 'modules/locations/pages/Locations/WorkplaceDetails'

const AuthorizedWorkplaceDetailsPage = () => {
  const { featureAvailability: hasGeofencingFeatureAvailability } = useFeatureAvailability(
    Features.time_tracking_geofencing_alerts
  )

  const hasGeofencingFeature = hasGeofencingFeatureAvailability.available
  const { has_dev_time_tracking_geofencing_block } = useFeatures([
    'dev_time_tracking_geofencing_block',
  ])

  return (
    <GoogleMapsProvider
      mapsEnabled={hasGeofencingFeature || has_dev_time_tracking_geofencing_block}
    >
      <WorkplaceDetailsComponent>
        <Outlet />
      </WorkplaceDetailsComponent>
    </GoogleMapsProvider>
  )
}

export default AuthorizedWorkplaceDetailsPage
